
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13427',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13427",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1054",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10068",
  "foundations-components": "static-1.8667",
  "foundations-components-legacy": "static-1.1692",
  "foundations-theming": "static-1.4903",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8459",
  "hub-http-shared-msw-handlers": "static-1.10817",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11912",
  "I18n": "static-7.1694",
  "jasmine-runner": "static-1.6871",
  "marketplace-discovery-studio-lib": "static-1.822",
  "marketplace-storefront-base": "static-1.13490",
  "quartz": "static-1.7595",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1.17154",
  "reactive-variable-buffer-atom": "static-1.3272",
  "reporting-testing-lib": "static-1.11134",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12951",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7777",
  "ui-addon-i18n": "static-1.11567",
  "ui-addon-react-router-dom": "static-1.9950",
  "unified-auth": "static-1.1146",
  "unified-auth-core-lib": "static-1.1428",
  "usage-tracker": "static-1.7735",
  "usage-tracker-core": "static-1.7585",
  "customer-data-property-utils": "static-1.8466",
  "hub-http": "static-1.6630",
  "integrations-lib": "static-1.17313",
  "marketplace-ui-common": "static-1.20965",
  "marketplace-ui-install": "static-1.951",
  "property-management-iframe": "static-1.14363",
  "quartz-config": "static-1.1373",
  "quartz-core": "static-1.6814",
  "quartz-routing": "static-1.1025",
  "quick-fetch": "static-1.4196",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5090",
  "ts-schema": "static-1.4366",
  "ui-universal-auth": "static-1.9632",
  "UIComponents": "static-3.8858",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3872",
  "quartz-webpack": "static-1.3819",
  "bend-plugin-quartz-routing": "static-1.673",
  "ai-components-ui-library": "static-1.9934",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5306",
  "pulse": "static-1.1061",
  "react-codemirror": "static-1.11061",
  "ui-extensions-preview-lib": "static-1.839",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4936",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2619",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9846",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.92",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5628",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.513",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2964",
  "ui-fonts": "static-1.1174",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3386",
  "foundations-theming-base": "static-1.3888",
  "stylex": "static-1.45",
  "HeadJS": "static-2.813",
  "hs-test-utils-bend-plugin": "static-1.3570",
  "msw": "static-1.102",
  "msw-config": "static-1.21",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4729",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11317",
  "chirp-fetch": "static-1.2322",
  "connections-embed-lib": "static-1.1670",
  "copilot-toolkit": "static-1.12057",
  "feedback-loader": "static-1.29984",
  "laboratory-lib": "static-3.7571",
  "marketplace-embed": "static-1.23113",
  "marketplace-ui-details": "static-1.10860",
  "marketplace-ui-reviews": "static-1.20920",
  "marketplace-ui-tracking": "static-1.15135",
  "sanitize-text": "static-1.8577",
  "usage-tracker-multi": "static-1.6149",
  "usage-tracker-session-replay": "static-1.5421",
  "wootric-nps": "static-1.7267",
  "quartz-head": "static-1.1260",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5021",
  "immer": "static-1.104",
  "immerable": "static-1.4562",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2785",
  "reporting-data": "static-1.69201",
  "cssUtils": "static-1.1043",
  "flux-actions": "static-1.379",
  "react-colorpicker": "static-2.10634",
  "react-dnd-compat": "static-1.5031",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10792",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7725",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19497",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4923",
  "foundations-components-test-utils": "static-1.6150",
  "quartz-i18n": "static-1.1270",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.676",
  "ads-unified-auth-lib": "static-1.1778",
  "custom-vendor-connection-lib": "static-1.196",
  "google-sheets-integration-lib": "static-1.1242",
  "microsoft-drive-auth-lib": "static-1.402",
  "surveymonkey-integration-lib": "static-1.771",
  "slack-ui-library": "static-1.10818",
  "fsm": "static-1.4175",
  "customer-data-objects": "static-1.8114",
  "property-translator": "static-1.5800",
  "hs-locale-management": "static-1.366",
  "frontend-preferences-client": "static-1.8339",
  "hs-promise-utils": "static-1.6010",
  "hubspot-apollo-client": "static-1.5298",
  "integrations-error-boundary-lib": "static-1.14728",
  "integrations-tracking-lib": "static-1.6032",
  "native-integrations-shared-strings": "static-1.8183",
  "sanitize": "static-1.4894",
  "superstore": "static-1.5179",
  "ui-shepherd-react": "static-3.10695",
  "ai-settings-ui-library": "static-1.8502",
  "hub-http-janus": "static-1.898",
  "hubspotter-http": "static-1.4933",
  "immutable-less": "static-1.5071",
  "marketplace-ui-client-types": "static-1.18372",
  "nav-meta": "static-1.30706",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18512",
  "ui-product-approvals-common": "static-1.1444",
  "ai-studio-lib": "static-1.12657",
  "hubspot-prosemirror": "static-1.19188",
  "integrations-reconnect-lib": "static-1.643",
  "ui-addon-iframeable": "static-1.9498",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-product-approvals": "static-1.29549",
  "ui-tool-access": "static-1.10575",
  "inbound-db-properties-service-client": "static-1.4113",
  "property-management-common": "static-1.6651",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1270",
  "quartz-test": "static-1.1270",
  "quartz-tracking": "static-1.974",
  "trellis-components": "static-1.2983",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.500",
  "HubStyle": "static-2.12219",
  "bender-build-tools": "static-1.3518",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.121",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23543",
  "ContentUtils": "static-1.69352",
  "customer-data-objects-ui-components": "static-1.13451",
  "sassPrefix": "static-1.309",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.564",
  "batch-promise": "static-1.1967",
  "event-emitter": "static-1.1380",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5857",
  "magpie-types": "static-1.5317",
  "stylex-utils": "static-1.162",
  "trellis-theming": "static-1.1405",
  "avatar-components": "static-1.2905",
  "breeze-engine-core": "static-1.1297",
  "breeze-onboarding-components": "static-1.967",
  "customer-data-filters-ui": "static-1.41237",
  "customer-data-reference-ui-components": "static-1.13588",
  "data-integrations-breeze": "static-1.209",
  "embedded-academy-lib": "static-1.15861",
  "ExportDialog": "static-6.10793",
  "global-styles-ai-lib": "static-1.403",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.816",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42275",
  "reporting-snowflake": "static-1.57817",
  "reporting-ui-components": "static-2.66470",
  "reporting-visualizations": "static-1.61275",
  "trial-components-library": "static-1.14297",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.658",
  "navigation-components": "static-1.19069",
  "breeze-engine-lib": "static-1.2019",
  "simple-logging-lib": "static-1.3472",
  "nudge-client-utils": "static-1.3330",
  "fail-safe": "static-1.374",
  "app-governance-lib": "static-1.2593",
  "developer-experience-shared-components": "static-1.10959",
  "purchase-motions-components": "static-1.6567",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10642",
  "usage-tracker-anonymous": "static-1.6152",
  "usage-tracker-public": "static-1.7546",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3744",
  "persist-promise": "static-1.4124",
  "reference-resolvers": "static-1.8598",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4337",
  "hubspot-apollo-cache": "static-1.757",
  "universal-page-editor-lib": "static-1.3430",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3740",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6873",
  "ui-addon-draggable": "static-3.5168",
  "content-assistance-lib": "static-1.8349",
  "content-media-capture": "static-1.5688",
  "customer-data-ui-utilities": "static-1.10254",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24752",
  "growth-payments-core": "static-1.26409",
  "knowledge-content-types": "static-1.8705",
  "PatternValidationJS": "static-1.3307",
  "payment-link-components": "static-1.24353",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20478",
  "ui-addon-emoji-picker": "static-1.10287",
  "ui-business-units-lib": "static-1.9516",
  "video-components-external": "static-1.12341",
  "video-data-lib": "static-1.35999",
  "navigation-messaging": "static-1.8396",
  "collaboration-sidebar": "static-1.58954",
  "trellis-ext-dnd": "static-1.463",
  "crm-component-utils": "static-1.40071",
  "crm-properties-common-lib": "static-1.6309",
  "customer-data-properties": "static-1.52898",
  "external-options-client-types": "static-1.4415",
  "framework-data-schema-resolvers": "static-1.7313",
  "property-value-citations": "static-1.3512",
  "reference-resolvers-lite": "static-1.8527",
  "hubspotter-http-shared-msw-handlers": "static-1.10815",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5233",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5498",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1144",
  "breeze-artifacts-sdk": "static-1.699",
  "getting-started-shared-tasks": "static-1.19473",
  "onboarding-journeys-lib": "static-1.1150",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43999",
  "customer-data-filters-ui-msw-helpers": "static-1.23672",
  "events-data-lib": "static-1.668",
  "FormUrlGenerator": "static-2.5135",
  "framework-builder-read-service-client": "static-1.4293",
  "hs-resources": "static-1.618",
  "multi-account-reference-resolvers": "static-1.1424",
  "onboarding-tours": "static-1.17312",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14680",
  "segments-client-types": "static-1.11987",
  "academy-common-lib": "static-1.15321",
  "dashboard-lib": "static-1.83180",
  "hubspot-prosemirror-plugins": "static-1.19180",
  "share-with-third-party-component-lib": "static-1.9132",
  "ui-asset-management-lib": "static-1.11522",
  "user-context": "static-1.5479",
  "reporting-plugins": "static-1.10910",
  "reporting-reports": "static-1.68877",
  "hubs-service-types": "static-1.1686",
  "purchase-motions-api": "static-1.6570",
  "salesImages": "static-1.678",
  "signup-constants": "static-1.19851",
  "nest": "static-1.656",
  "breeze-engine-chat-components": "static-1.997",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3087",
  "nudge-renderer-utils": "static-1.3406",
  "whisper-core-api": "static-1.7545",
  "bend-plugin-fail-safe": "static-1.325",
  "framework-listing-lib": "static-2.29711",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31657",
  "apps-service-types": "static-1.4068",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8480",
  "onboarding-tours-client": "static-1.5527",
  "one-click-checkout": "static-1.662",
  "platform-infra-nav-components": "static-1.7970",
  "subscription-experience-data-types": "static-1.15372",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10329",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29516",
  "content-media-composition-data-lib": "static-1.13492",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4847",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3895",
  "seat-types-lib": "static-1.951",
  "ui-addon-opt": "static-4.8805",
  "commerce-tours-lib": "static-1.6788",
  "growth-onboarding-reliability": "static-1.5503",
  "sales-checkout-service-client": "static-1.3950",
  "data-token-picker": "static-1.17050",
  "FileManagerLib": "static-1.40392",
  "content-media-compositions": "static-2.17499",
  "media-bridge-lib": "static-1.19564",
  "chatspot-widget-iframe": "static-1.23534",
  "collaboration-sidebar-common": "static-1.3751",
  "marketing-platform-lib": "static-1.7313",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45230",
  "commerce-subscription-lib": "static-1.38002",
  "crm-actions": "static-1.6771",
  "crm-cards-sdk": "static-1.44885",
  "customer-data-properties-shared-msw-handlers": "static-1.10144",
  "customer-data-tracking": "static-1.7293",
  "calling-global-api": "static-1.66034",
  "calling-internal-common": "static-1.31745",
  "calling-lifecycle-internal": "static-1.67416",
  "calling-lifecycle-messages": "static-1.59709",
  "commerce-products-lib": "static-1.10776",
  "conditional-properties-service-client": "static-1.4086",
  "crm-index-visualization-core": "static-1.4684",
  "crm-links": "static-1.6726",
  "crm-pipelines-api-client-types": "static-1.4417",
  "formula-editor": "static-1.14941",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4496",
  "meetings-icalendar-utils-lib": "static-1.1058",
  "multi-currency-client-types": "static-1.3982",
  "object-builder-ui-client": "static-1.49936",
  "pipeline-validation-client-types": "static-1.4254",
  "smart-data-capture-core": "static-1.365",
  "smart-property-lib": "static-1.8533",
  "tiered-pricing": "static-1.2153",
  "topics-actions-lib": "static-1.596",
  "ui-addon-form-validation": "static-1.11340",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.432",
  "framework-data-schema-quick-fetch": "static-1.7218",
  "restore-request-side-panel-lib": "static-1.1928",
  "growth-data-modal": "static-1.6058",
  "growth-onboarding-confetti": "static-1.3484",
  "growth-onboarding-next-action-utils": "static-1.2898",
  "onboarding-tours-utils": "static-1.1379",
  "ui-shepherd-tracker": "static-1.8076",
  "crm-index-associations-lib": "static-1.6869",
  "academy-service-client": "static-1.4114",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40251",
  "SafeStorage": "static-1.4814",
  "video-embed": "static-1.36833",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25166",
  "viral-links-lib": "static-1.7500",
  "nested-table": "static-1.656",
  "timezone-utils": "static-2.5652",
  "getting-started-shared-tasks-store": "static-1.18591",
  "campaign-roi-lib": "static-1.10665",
  "campaigns-utils-lib": "static-1.3654",
  "ui-addon-calendars": "static-2.5784",
  "customer-data-views-management": "static-1.26232",
  "framework-data-table": "static-2.12758",
  "nudge-custom-ui-functions": "static-1.1667",
  "switchboard-lib": "static-1.645",
  "access-check-ui-lib": "static-1.1800",
  "app-users-service-client": "static-1.6040",
  "app-users-service-types": "static-1.5448",
  "mini-checkout-client": "static-1.27757",
  "onboarding-utils": "static-1.5792",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29501",
  "checkout-sdk": "static-3.24600",
  "payment-method-components": "static-1.7266",
  "touchless-buying-components": "static-1.6468",
  "upgrade-catalog-service-types": "static-1.3846",
  "edison-service-client-types": "static-1.814",
  "growth-onboarding-feedback-components": "static-1.7003",
  "audio-components": "static-1.6497",
  "FileManagerImages": "static-1.37903",
  "video-components": "static-1.14343",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93093",
  "customer-data-sidebar": "static-2.46934",
  "enrichment-lib": "static-1.801",
  "ui-addon-draggable-compat": "static-2.4682",
  "universal-record-utils-lib": "static-1.2251",
  "commerce-billing-lib": "static-1.20443",
  "commerce-shared-components-lib": "static-1.19485",
  "commerce-tools-ui-lib": "static-1.11238",
  "crm-fe-perf": "static-1.23317",
  "calling-error-reporting": "static-1.31752",
  "shared-worker-versioning": "static-1.11461",
  "calling-usage-tracker": "static-1.6955",
  "voice-sms-access-library": "static-1.2330",
  "commerce-permissions": "static-1.1200",
  "products-iframe-lib": "static-1.8813",
  "products-ui-components-shared-msw-handlers": "static-1.11199",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10900",
  "sales-views-client-types": "static-1.4679",
  "bark-lib": "static-1.16952",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.818",
  "policy-lib": "static-1.7227",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10963",
  "onboarding-data-sync-lib": "static-1.2759",
  "growth-onboarding-next-action-components": "static-1.2926",
  "user-context-client": "static-1.4930",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4937",
  "outpost": "static-1.4554",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22280",
  "sales-email-signature-service-client": "static-1.4271",
  "ts-utils-lib": "static-1.569",
  "copilot-messaging": "static-1.2307",
  "crm-export-dialog": "static-1.6698",
  "crm-index-ui-shimmer": "static-1.2891",
  "crm-view-components": "static-1.1411",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7752",
  "tasks-actions-lib": "static-1.343",
  "InboxConnectUtils": "static-4.15758",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47057",
  "hub-http-rxjs": "static-1.867",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4411",
  "company-details-components": "static-1.6626",
  "react-performance-metrics-lib": "static-1.971",
  "pricing-pages-ui-components": "static-1.16348",
  "quote-checkout-service-types": "static-1.3877",
  "social-insights-client-types": "static-1.22848",
  "crm_universal": "static-1.22648",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38209",
  "commerce-contract-lib": "static-1.13667",
  "invoices-highlight-card-lib": "static-1.56066",
  "orders-highlight-card-lib": "static-1.22414",
  "products-highlight-card-lib": "static-1.19059",
  "quotes-highlight-card-lib": "static-1.73001",
  "crm-source-interpretation-lib": "static-1.5749",
  "data-agent-test-utils": "static-1.362",
  "data-agent-utils": "static-1.831",
  "enrichment-settings-lib": "static-1.146",
  "crm-object-search-query-utilities": "static-1.10383",
  "utility-belt": "static-1.2956",
  "payments-enrollment-embed-lib": "static-1.24109",
  "stripe-embedded-components": "static-1.8164",
  "customer-data-rte": "static-1.33818",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6455",
  "payments-post-enroll-local-storage-lib": "static-1.5524",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39091",
  "calling-orchestration-schema": "static-1.37107",
  "react-reducer-toolkit": "static-1.16579",
  "meetings-connect-utils-lib": "static-1.8037",
  "hub-http-contrib": "static-1.3449",
  "ui-addon-sales-email": "static-1.5623",
  "access-control-lib": "static-1.10849",
  "EmailComponents": "static-1.55755",
  "EmailData": "static-1.54433",
  "messaging-base-table-lib": "static-1.714",
  "redux-less": "static-2.9881",
  "company-details-service-types": "static-1.4363",
  "segments-query-core": "static-1.1850",
  "pricing-pages-api": "static-1.16213",
  "sequences-lib": "static-1.8693",
  "ui-gdpr-components": "static-1.10650",
  "products-ui-components": "static-1.41294",
  "reporting-enablement": "static-1.24067",
  "accounting-integrations-ui-components": "static-1.7720",
  "invoices-ui-lib": "static-1.56082",
  "commerce-products-api": "static-1.2845",
  "invoices-iframe-lib": "static-1.58140",
  "quotes-modal-lib": "static-1.103679",
  "quotes-ui-lib": "static-1.81722",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29076",
  "ContentComponents": "static-2.72308",
  "ContentData": "static-1.69427",
  "marketing-email-service-types": "static-1.2180",
  "messaging-editing-lib": "static-1.47371",
  "messaging-usage-based-billing-components-lib": "static-1.2233",
  "automation-ui-source-apps": "static-1.19889",
  "automation-ui-types": "static-1.20807",
  "messaging-types-lib": "static-1.47108",
  "onboarding-settings-client": "static-1.4930",
  "sequences-client-types-lib": "static-1.8550",
  "commerce-tax-lib": "static-1.957",
  "price-books-api": "static-1.1938",
  "price-books-components": "static-1.1996",
  "property-description-translator": "static-1.4241",
  "ramp-editor": "static-1.1087",
  "data-quality-ui-library": "static-1.14182",
  "report-customization-components": "static-1.14119",
  "reporting-filters": "static-1.1210",
  "reporting-insights-lib": "static-1.2827",
  "commerce-analytics-service-client": "static-1.3938",
  "totals-ui-components": "static-1.24483",
  "SalesContentIndexUI": "static-3.9691",
  "advanced-menus-core": "static-1.15738",
  "advanced-menus-lib": "static-1.12513",
  "automation-ui-ubb": "static-1.6723",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7760",
  "data-token-views": "static-1.17031",
  "forms-utils-lib": "static-1.13257",
  "payments-embed-points-lib": "static-1.13769",
  "react-tinymce": "static-1.56180",
  "simple-menus-core": "static-1.15737",
  "simple-menus-lib": "static-1.17254",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55306",
  "tinymce-data": "static-1.41391",
  "tinymce-plugins": "static-1.58420",
  "tinymce-themes": "static-1.57276",
  "ui-brand-identity-lib": "static-1.16807",
  "ui-memberships-settings-lib": "static-1.35091",
  "videoconference-integration-components": "static-1.7457",
  "automation-applications-service-types": "static-1.3698",
  "automation-platform-service-types": "static-1.2709",
  "ContentEditorUI": "static-2.78140",
  "content-whatsapp-service-types": "static-1.645",
  "short-messages-app-service-client": "static-1.4346",
  "web-interactives-components": "static-1.14412",
  "web-interactives-data": "static-1.14413",
  "messaging-shared-utils-lib": "static-1.1682",
  "messaging-user-info-utils-lib": "static-1.1852",
  "email-portal-health-service-types": "static-1.1403",
  "line-items-api": "static-1.1256",
  "merge-modal-lib": "static-1.12938",
  "commerce-totals-service-types": "static-1.4105",
  "FireAlarmUi": "static-1.4807",
  "sales-templates-service-types-lib": "static-1.4457",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22743",
  "automation-ui-usage-tracking": "static-1.22206",
  "data-studio-ubb": "static-1.3724",
  "interframe": "static-3.5161",
  "layout-dnd-components": "static-1.13141",
  "layout-dnd-utils": "static-1.12116",
  "NamespacedHubStyle": "static-2.9329",
  "campaigns-lib": "static-1.27821",
  "content-management-data-lib": "static-1.6150",
  "copilot-plugins": "static-1.12029",
  "cta-picker": "static-1.37167",
  "customer-agent-discovery-components-lib": "static-1.4176",
  "editor-components": "static-1.13813",
  "editor-iframe-lib": "static-1.8937",
  "error-messaging-js": "static-1.5556",
  "FormsCommonComponents": "static-1.86753",
  "layout-data-lib": "static-1.10441",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11060",
  "SharedLegalStrings": "static-1.2150",
  "smart-content-core": "static-1.43374",
  "smart-content-lib": "static-1.44027",
  "social-composer-lib": "static-1.60505",
  "structured-content-lib": "static-1.26109",
  "theme-previewer-lib": "static-1.54088",
  "tinymce-copilot": "static-1.17374",
  "xray-recommendation-lib": "static-1.8394",
  "automation-ui-routing": "static-1.22164",
  "sql-reporting-client-types": "static-1.5976",
  "attribution-lib": "static-1.42936",
  "voice-agents-components": "static-1.3991",
  "forms-ai-lib": "static-1.4908",
  "codemirror-dlb": "static-1.59699",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6866",
  "calling-orchestration-shared-library": "static-1.36882"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13427",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1054",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10068",
  "foundations-components": "/foundations-components/static-1.8667",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1692",
  "foundations-theming": "/foundations-theming/static-1.4903",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8459",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10817",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11912",
  "I18n": "/I18n/static-7.1694",
  "jasmine-runner": "/jasmine-runner/static-1.6871",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.822",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13490",
  "quartz": "/quartz/static-1.7595",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1.17154",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3272",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11134",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12951",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7777",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11567",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9950",
  "unified-auth": "/unified-auth/static-1.1146",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1428",
  "usage-tracker": "/usage-tracker/static-1.7735",
  "usage-tracker-core": "/usage-tracker-core/static-1.7585",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8466",
  "hub-http": "/hub-http/static-1.6630",
  "integrations-lib": "/integrations-lib/static-1.17313",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20965",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.951",
  "property-management-iframe": "/property-management-iframe/static-1.14363",
  "quartz-config": "/quartz-config/static-1.1373",
  "quartz-core": "/quartz-core/static-1.6814",
  "quartz-routing": "/quartz-routing/static-1.1025",
  "quick-fetch": "/quick-fetch/static-1.4196",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5090",
  "ts-schema": "/ts-schema/static-1.4366",
  "ui-universal-auth": "/ui-universal-auth/static-1.9632",
  "UIComponents": "/UIComponents/static-3.8858",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3872",
  "quartz-webpack": "/quartz-webpack/static-1.3819",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.673",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9934",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5306",
  "pulse": "/pulse/static-1.1061",
  "react-codemirror": "/react-codemirror/static-1.11061",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.839",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4936",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2619",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9846",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.92",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5628",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2964",
  "ui-fonts": "/ui-fonts/static-1.1174",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3386",
  "foundations-theming-base": "/foundations-theming-base/static-1.3888",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.813",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3570",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.21",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4729",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11317",
  "chirp-fetch": "/chirp-fetch/static-1.2322",
  "connections-embed-lib": "/connections-embed-lib/static-1.1670",
  "copilot-toolkit": "/copilot-toolkit/static-1.12057",
  "feedback-loader": "/feedback-loader/static-1.29984",
  "laboratory-lib": "/laboratory-lib/static-3.7571",
  "marketplace-embed": "/marketplace-embed/static-1.23113",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10860",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20920",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15135",
  "sanitize-text": "/sanitize-text/static-1.8577",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6149",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5421",
  "wootric-nps": "/wootric-nps/static-1.7267",
  "quartz-head": "/quartz-head/static-1.1260",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5021",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4562",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2785",
  "reporting-data": "/reporting-data/static-1.69201",
  "cssUtils": "/cssUtils/static-1.1043",
  "flux-actions": "/flux-actions/static-1.379",
  "react-colorpicker": "/react-colorpicker/static-2.10634",
  "react-dnd-compat": "/react-dnd-compat/static-1.5031",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10792",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7725",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19497",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4923",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6150",
  "quartz-i18n": "/quartz-i18n/static-1.1270",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.676",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1778",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.196",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1242",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.402",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.771",
  "slack-ui-library": "/slack-ui-library/static-1.10818",
  "fsm": "/fsm/static-1.4175",
  "customer-data-objects": "/customer-data-objects/static-1.8114",
  "property-translator": "/property-translator/static-1.5800",
  "hs-locale-management": "/hs-locale-management/static-1.366",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8339",
  "hs-promise-utils": "/hs-promise-utils/static-1.6010",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5298",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14728",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6032",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8183",
  "sanitize": "/sanitize/static-1.4894",
  "superstore": "/superstore/static-1.5179",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10695",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8502",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hubspotter-http": "/hubspotter-http/static-1.4933",
  "immutable-less": "/immutable-less/static-1.5071",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18372",
  "nav-meta": "/nav-meta/static-1.30706",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18512",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1444",
  "ai-studio-lib": "/ai-studio-lib/static-1.12657",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19188",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.643",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9498",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-product-approvals": "/ui-product-approvals/static-1.29549",
  "ui-tool-access": "/ui-tool-access/static-1.10575",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4113",
  "property-management-common": "/property-management-common/static-1.6651",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1270",
  "quartz-test": "/quartz-test/static-1.1270",
  "quartz-tracking": "/quartz-tracking/static-1.974",
  "trellis-components": "/trellis-components/static-1.2983",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.500",
  "HubStyle": "/HubStyle/static-2.12219",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.121",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23543",
  "ContentUtils": "/ContentUtils/static-1.69352",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13451",
  "sassPrefix": "/sassPrefix/static-1.309",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.564",
  "batch-promise": "/batch-promise/static-1.1967",
  "event-emitter": "/event-emitter/static-1.1380",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5857",
  "magpie-types": "/magpie-types/static-1.5317",
  "stylex-utils": "/stylex-utils/static-1.162",
  "trellis-theming": "/trellis-theming/static-1.1405",
  "avatar-components": "/avatar-components/static-1.2905",
  "breeze-engine-core": "/breeze-engine-core/static-1.1297",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.967",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41237",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13588",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.209",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15861",
  "ExportDialog": "/ExportDialog/static-6.10793",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.403",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.816",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42275",
  "reporting-snowflake": "/reporting-snowflake/static-1.57817",
  "reporting-ui-components": "/reporting-ui-components/static-2.66470",
  "reporting-visualizations": "/reporting-visualizations/static-1.61275",
  "trial-components-library": "/trial-components-library/static-1.14297",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.658",
  "navigation-components": "/navigation-components/static-1.19069",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2019",
  "simple-logging-lib": "/simple-logging-lib/static-1.3472",
  "nudge-client-utils": "/nudge-client-utils/static-1.3330",
  "fail-safe": "/fail-safe/static-1.374",
  "app-governance-lib": "/app-governance-lib/static-1.2593",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10959",
  "purchase-motions-components": "/purchase-motions-components/static-1.6567",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10642",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6152",
  "usage-tracker-public": "/usage-tracker-public/static-1.7546",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
  "persist-promise": "/persist-promise/static-1.4124",
  "reference-resolvers": "/reference-resolvers/static-1.8598",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4337",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.757",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3430",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3740",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6873",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5168",
  "content-assistance-lib": "/content-assistance-lib/static-1.8349",
  "content-media-capture": "/content-media-capture/static-1.5688",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10254",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24752",
  "growth-payments-core": "/growth-payments-core/static-1.26409",
  "knowledge-content-types": "/knowledge-content-types/static-1.8705",
  "PatternValidationJS": "/PatternValidationJS/static-1.3307",
  "payment-link-components": "/payment-link-components/static-1.24353",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20478",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10287",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9516",
  "video-components-external": "/video-components-external/static-1.12341",
  "video-data-lib": "/video-data-lib/static-1.35999",
  "navigation-messaging": "/navigation-messaging/static-1.8396",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58954",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.463",
  "crm-component-utils": "/crm-component-utils/static-1.40071",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6309",
  "customer-data-properties": "/customer-data-properties/static-1.52898",
  "external-options-client-types": "/external-options-client-types/static-1.4415",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7313",
  "property-value-citations": "/property-value-citations/static-1.3512",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8527",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10815",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5233",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5498",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1144",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.699",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19473",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43999",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23672",
  "events-data-lib": "/events-data-lib/static-1.668",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5135",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4293",
  "hs-resources": "/hs-resources/static-1.618",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1424",
  "onboarding-tours": "/onboarding-tours/static-1.17312",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14680",
  "segments-client-types": "/segments-client-types/static-1.11987",
  "academy-common-lib": "/academy-common-lib/static-1.15321",
  "dashboard-lib": "/dashboard-lib/static-1.83180",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19180",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9132",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11522",
  "user-context": "/user-context/static-1.5479",
  "reporting-plugins": "/reporting-plugins/static-1.10910",
  "reporting-reports": "/reporting-reports/static-1.68877",
  "hubs-service-types": "/hubs-service-types/static-1.1686",
  "purchase-motions-api": "/purchase-motions-api/static-1.6570",
  "salesImages": "/salesImages/static-1.678",
  "signup-constants": "/signup-constants/static-1.19851",
  "nest": "/nest/static-1.656",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.997",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3087",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3406",
  "whisper-core-api": "/whisper-core-api/static-1.7545",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.325",
  "framework-listing-lib": "/framework-listing-lib/static-2.29711",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31657",
  "apps-service-types": "/apps-service-types/static-1.4068",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8480",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5527",
  "one-click-checkout": "/one-click-checkout/static-1.662",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7970",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15372",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10329",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29516",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13492",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4847",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3895",
  "seat-types-lib": "/seat-types-lib/static-1.951",
  "ui-addon-opt": "/ui-addon-opt/static-4.8805",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6788",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5503",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3950",
  "data-token-picker": "/data-token-picker/static-1.17050",
  "FileManagerLib": "/FileManagerLib/static-1.40392",
  "content-media-compositions": "/content-media-compositions/static-2.17499",
  "media-bridge-lib": "/media-bridge-lib/static-1.19564",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23534",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3751",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7313",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45230",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38002",
  "crm-actions": "/crm-actions/static-1.6771",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44885",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10144",
  "customer-data-tracking": "/customer-data-tracking/static-1.7293",
  "calling-global-api": "/calling-global-api/static-1.66034",
  "calling-internal-common": "/calling-internal-common/static-1.31745",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67416",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59709",
  "commerce-products-lib": "/commerce-products-lib/static-1.10776",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4684",
  "crm-links": "/crm-links/static-1.6726",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
  "formula-editor": "/formula-editor/static-1.14941",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4496",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1058",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3982",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49936",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4254",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.365",
  "smart-property-lib": "/smart-property-lib/static-1.8533",
  "tiered-pricing": "/tiered-pricing/static-1.2153",
  "topics-actions-lib": "/topics-actions-lib/static-1.596",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11340",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.432",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7218",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1928",
  "growth-data-modal": "/growth-data-modal/static-1.6058",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3484",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2898",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1379",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8076",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6869",
  "academy-service-client": "/academy-service-client/static-1.4114",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40251",
  "SafeStorage": "/SafeStorage/static-1.4814",
  "video-embed": "/video-embed/static-1.36833",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25166",
  "viral-links-lib": "/viral-links-lib/static-1.7500",
  "nested-table": "/nested-table/static-1.656",
  "timezone-utils": "/timezone-utils/static-2.5652",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18591",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10665",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3654",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5784",
  "customer-data-views-management": "/customer-data-views-management/static-1.26232",
  "framework-data-table": "/framework-data-table/static-2.12758",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1667",
  "switchboard-lib": "/switchboard-lib/static-1.645",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1800",
  "app-users-service-client": "/app-users-service-client/static-1.6040",
  "app-users-service-types": "/app-users-service-types/static-1.5448",
  "mini-checkout-client": "/mini-checkout-client/static-1.27757",
  "onboarding-utils": "/onboarding-utils/static-1.5792",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29501",
  "checkout-sdk": "/checkout-sdk/static-3.24600",
  "payment-method-components": "/payment-method-components/static-1.7266",
  "touchless-buying-components": "/touchless-buying-components/static-1.6468",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3846",
  "edison-service-client-types": "/edison-service-client-types/static-1.814",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7003",
  "audio-components": "/audio-components/static-1.6497",
  "FileManagerImages": "/FileManagerImages/static-1.37903",
  "video-components": "/video-components/static-1.14343",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93093",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46934",
  "enrichment-lib": "/enrichment-lib/static-1.801",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4682",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2251",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20443",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19485",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11238",
  "crm-fe-perf": "/crm-fe-perf/static-1.23317",
  "calling-error-reporting": "/calling-error-reporting/static-1.31752",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11461",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6955",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2330",
  "commerce-permissions": "/commerce-permissions/static-1.1200",
  "products-iframe-lib": "/products-iframe-lib/static-1.8813",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11199",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10900",
  "sales-views-client-types": "/sales-views-client-types/static-1.4679",
  "bark-lib": "/bark-lib/static-1.16952",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.818",
  "policy-lib": "/policy-lib/static-1.7227",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10963",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2759",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2926",
  "user-context-client": "/user-context-client/static-1.4930",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4937",
  "outpost": "/outpost/static-1.4554",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22280",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4271",
  "ts-utils-lib": "/ts-utils-lib/static-1.569",
  "copilot-messaging": "/copilot-messaging/static-1.2307",
  "crm-export-dialog": "/crm-export-dialog/static-1.6698",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2891",
  "crm-view-components": "/crm-view-components/static-1.1411",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7752",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.343",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15758",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47057",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.867",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4411",
  "company-details-components": "/company-details-components/static-1.6626",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.971",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16348",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3877",
  "social-insights-client-types": "/social-insights-client-types/static-1.22848",
  "crm_universal": "/crm_universal/static-1.22648",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38209",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13667",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56066",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22414",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19059",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73001",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5749",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.362",
  "data-agent-utils": "/data-agent-utils/static-1.831",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.146",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10383",
  "utility-belt": "/utility-belt/static-1.2956",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24109",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8164",
  "customer-data-rte": "/customer-data-rte/static-1.33818",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6455",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5524",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39091",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37107",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16579",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8037",
  "hub-http-contrib": "/hub-http-contrib/static-1.3449",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5623",
  "access-control-lib": "/access-control-lib/static-1.10849",
  "EmailComponents": "/EmailComponents/static-1.55755",
  "EmailData": "/EmailData/static-1.54433",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.714",
  "redux-less": "/redux-less/static-2.9881",
  "company-details-service-types": "/company-details-service-types/static-1.4363",
  "segments-query-core": "/segments-query-core/static-1.1850",
  "pricing-pages-api": "/pricing-pages-api/static-1.16213",
  "sequences-lib": "/sequences-lib/static-1.8693",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10650",
  "products-ui-components": "/products-ui-components/static-1.41294",
  "reporting-enablement": "/reporting-enablement/static-1.24067",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7720",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56082",
  "commerce-products-api": "/commerce-products-api/static-1.2845",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58140",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103679",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81722",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29076",
  "ContentComponents": "/ContentComponents/static-2.72308",
  "ContentData": "/ContentData/static-1.69427",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2180",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47371",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2233",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19889",
  "automation-ui-types": "/automation-ui-types/static-1.20807",
  "messaging-types-lib": "/messaging-types-lib/static-1.47108",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4930",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8550",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.957",
  "price-books-api": "/price-books-api/static-1.1938",
  "price-books-components": "/price-books-components/static-1.1996",
  "property-description-translator": "/property-description-translator/static-1.4241",
  "ramp-editor": "/ramp-editor/static-1.1087",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14182",
  "report-customization-components": "/report-customization-components/static-1.14119",
  "reporting-filters": "/reporting-filters/static-1.1210",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2827",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3938",
  "totals-ui-components": "/totals-ui-components/static-1.24483",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9691",
  "advanced-menus-core": "/advanced-menus-core/static-1.15738",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12513",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6723",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7760",
  "data-token-views": "/data-token-views/static-1.17031",
  "forms-utils-lib": "/forms-utils-lib/static-1.13257",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13769",
  "react-tinymce": "/react-tinymce/static-1.56180",
  "simple-menus-core": "/simple-menus-core/static-1.15737",
  "simple-menus-lib": "/simple-menus-lib/static-1.17254",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55306",
  "tinymce-data": "/tinymce-data/static-1.41391",
  "tinymce-plugins": "/tinymce-plugins/static-1.58420",
  "tinymce-themes": "/tinymce-themes/static-1.57276",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16807",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35091",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7457",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3698",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2709",
  "ContentEditorUI": "/ContentEditorUI/static-2.78140",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.645",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4346",
  "web-interactives-components": "/web-interactives-components/static-1.14412",
  "web-interactives-data": "/web-interactives-data/static-1.14413",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1682",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1852",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1403",
  "line-items-api": "/line-items-api/static-1.1256",
  "merge-modal-lib": "/merge-modal-lib/static-1.12938",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4105",
  "FireAlarmUi": "/FireAlarmUi/static-1.4807",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4457",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22743",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22206",
  "data-studio-ubb": "/data-studio-ubb/static-1.3724",
  "interframe": "/interframe/static-3.5161",
  "layout-dnd-components": "/layout-dnd-components/static-1.13141",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12116",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9329",
  "campaigns-lib": "/campaigns-lib/static-1.27821",
  "content-management-data-lib": "/content-management-data-lib/static-1.6150",
  "copilot-plugins": "/copilot-plugins/static-1.12029",
  "cta-picker": "/cta-picker/static-1.37167",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4176",
  "editor-components": "/editor-components/static-1.13813",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8937",
  "error-messaging-js": "/error-messaging-js/static-1.5556",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86753",
  "layout-data-lib": "/layout-data-lib/static-1.10441",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11060",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2150",
  "smart-content-core": "/smart-content-core/static-1.43374",
  "smart-content-lib": "/smart-content-lib/static-1.44027",
  "social-composer-lib": "/social-composer-lib/static-1.60505",
  "structured-content-lib": "/structured-content-lib/static-1.26109",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54088",
  "tinymce-copilot": "/tinymce-copilot/static-1.17374",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8394",
  "automation-ui-routing": "/automation-ui-routing/static-1.22164",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5976",
  "attribution-lib": "/attribution-lib/static-1.42936",
  "voice-agents-components": "/voice-agents-components/static-1.3991",
  "forms-ai-lib": "/forms-ai-lib/static-1.4908",
  "codemirror-dlb": "/codemirror-dlb/static-1.59699",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6866",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36882"
}
};
